import { motion } from "framer-motion";
import { ShieldCheck, FileDown } from "lucide-react";
import { MarketingNav, Footer } from "@/components/MarketingNav";
import { API } from "@/lib/api";

export default function Trasparenza() {
  const points = [
    "Una segnalazione non garantisce un incarico.",
    "Un incarico non garantisce una vendita.",
    "Una proposta non equivale necessariamente a un affare concluso.",
    "Il merito fidelizzazione viene riconosciuto esclusivamente quando si verificano le condizioni stabilite dal programma.",
    "L'attività del segnalatore resta distinta dall'attività professionale di mediazione immobiliare.",
    "Privacy, consenso al contatto, trattamento dei dati e aspetti fiscali sono gestiti secondo la normativa applicabile.",
  ];
  return (
    <div className="min-h-screen bg-[#0A1128] text-white">
      <MarketingNav />
      <section className="pt-32 pb-16 mx-auto max-w-4xl px-5 sm:px-8">
        <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
          <span className="inline-flex items-center gap-2 rounded-full border border-[#D4AF37]/40 bg-[#D4AF37]/10 px-4 py-1.5 text-xs font-medium text-[#E6C965]">
            <ShieldCheck className="h-3.5 w-3.5" /> Trasparenza prima di tutto
          </span>
          <h1 className="mt-5 font-display text-4xl sm:text-5xl font-semibold leading-tight">
            Vogliamo essere chiari con te.
          </h1>
          <p className="mt-6 text-white/70 leading-relaxed text-lg">
            Preferiamo dirti le cose come stanno. Ecco cosa significa realmente partecipare al
            programma segnalatori.
          </p>
        </motion.div>
      </section>
      <section className="pb-24 mx-auto max-w-4xl px-5 sm:px-8">
        <div className="space-y-3">
          {points.map((p, i) => (
            <motion.div key={i}
              initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.35, delay: i * 0.04 }}
              className="rounded-xl border-l-2 border-[#D4AF37] bg-white/5 px-6 py-5 text-white/80 leading-relaxed">
              {p}
            </motion.div>
          ))}
        </div>
        <p className="mt-8 text-sm text-white/40">
          I testi legali definitivi potranno essere sostituiti con quelli approvati da un
          professionista legale/fiscale.
        </p>

        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          <a href={`${API}/documents/privacy.pdf`} target="_blank" rel="noopener noreferrer" data-testid="download-privacy"
            className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/5 px-5 py-4 hover:bg-white/10 transition-colors">
            <FileDown className="h-5 w-5 text-[#D4AF37]" />
            <span className="text-sm text-white/90">Scarica l'Informativa Privacy (PDF)</span>
          </a>
          <a href={`${API}/documents/programma-segnalatori.pdf`} target="_blank" rel="noopener noreferrer" data-testid="download-programma"
            className="flex items-center gap-3 rounded-xl border border-white/15 bg-white/5 px-5 py-4 hover:bg-white/10 transition-colors">
            <FileDown className="h-5 w-5 text-[#D4AF37]" />
            <span className="text-sm text-white/90">Scarica i Termini del Programma (8–12%) (PDF)</span>
          </a>
        </div>
      </section>
      <Footer />
    </div>
  );
}
